module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n.modal-dialog {\n  width: 96%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/styles/modal_stats.less
// module id = 1178
// module chunks = 1